/** Un seul rejeu des lectures lors d'un incident temporaire. Jamais de rejeu
 * d'une mutation, d'un refus 401/403 ou d'une opération fournisseur. */
export async function sessionFetch(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  const response = await fetch(input, init);
  init?.signal?.throwIfAborted();
  if ((init?.method ?? 'GET') !== 'GET' || ![502, 503, 504].includes(response.status))
    return response;
  await response.body?.cancel();
  await new Promise<void>((resolve) => window.setTimeout(resolve, 150));
  init?.signal?.throwIfAborted();
  return fetch(input, init);
}
